<template>
  <div>
    <b-container fluid>
      <b-row class="chameleon-hero-container d-flex justify-content-center align-content-center">
        <b-col cols="12" class="">
          <create-job-form/>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col cols="12">
          <my-jobs-table/>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import CreateJobForm from '../components/jobs/CreateJobForm.vue';
  import MyJobsTable from '../components/jobs/MyJobsTable.vue';

  export default {
    components: {
      CreateJobForm,
      MyJobsTable,
    },
  };
</script>

<style scoped>

</style>
